export default [
  {
    path: "/price-monitoring/dashboard",
    name: "price-monitoring.dashboard",
    component: () => import("@/views/price-monitoring/PriceMonitoringDashboard.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Dashboard de Preços",
      breadcrumb: [
        {
          text: "Monitoramento de preços",
          route: { name: "price-monitoring.dashboard" }
        },
        {
          text: "Dashboard",
          active: true
        }
      ]
    }
  },
  {
    path: "/price-monitoring/alerts",
    name: "price-monitoring.alerts",
    component: () => import("@/views/price-monitoring/PriceMonitoringAlerts.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Alertas de Preços",
      breadcrumb: [
        {
          text: "Monitoramento de preços",
          route: { name: "price-monitoring.dashboard" }
        },
        {
          text: "Alertas",
          active: true
        }
      ]
    }
  },
  {
    path: "/price-monitoring/history",
    name: "price-monitoring.history",
    component: () => import("@/views/price-monitoring/PriceMonitoringHistory.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Histórico de Preços",
      breadcrumb: [
        {
          text: "Monitoramento de preços",
          route: { name: "price-monitoring.dashboard" }
        },
        {
          text: "Histórico",
          active: true
        }
      ]
    }
  },
  {
    path: "/price-monitoring/settings",
    name: "price-monitoring.settings",
    component: () => import("@/views/price-monitoring/PriceMonitoringSettings.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      pageTitle: "Configurações de Monitoramento",
      breadcrumb: [
        {
          text: "Monitoramento de preços",
          route: { name: "price-monitoring.dashboard" }
        },
        {
          text: "Configurações",
          active: true
        }
      ]
    }
  }
];
